export const createSlugFromName = (name: string) =>
  name
    ? name
        .trim()
        .toLowerCase()
        .replace(/[\s_]+/g, '-') // Replace spaces and underscores with hyphens
        .replace(/[^\w/-]+/g, '-') // Remove all non-word characters except hyphens and slashes
        .replace(/--+/g, '-') // Replace multiple hyphens with a single hyphen
        .replace(/^-+/, '') // Remove leading hyphens
        .replace(/-+$/, '') // Remove trailing hyphens
    : '';
